<template>
    <div>
        <public-header title="角色管理"></public-header>
        <ak-model-filter-card model="role" @search="search" @reset="reset" />
        <div class="myCard">
            <ak-model-card model="role" ref="role" :page.sync="page" :filters="filters" tableSize="small"/>
        </div>
    </div>
  </template>
<script>

import publicHeader from '../../components/publicHeader.vue'

export default {
  components: {
    publicHeader
  },
  data () {
    return {
      filters: {
        isDelete: false
      },
      page: Number(this.$route.query.page) || 1
    }
  },
  watch: {
    page (val) {
      this.$router.replace({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { page: this.page })
      })
    }
  },
  mounted () {
  },
  methods: {
    search (filters) {
      this.page = 1
      this.filters = { isDelete: false }
      this.filters = { ...this.filters, ...filters }
    },
    reset () {
      this.page = 1
      this.filters = { isDelete: false }
    }
  }
}
</script>
  <style lang="scss" scoped>
  .myTab {
    padding: 24px 0 0 24px;
  }
  </style>
